// React things
import React, { useEffect, useState } from "react";

// Rive
import {
  useRive,
  Layout,
  Fit,
  Alignment,
  EventType,
} from "@rive-app/react-canvas";

// Stores
import useSourceStore from "../Store/SourceStore.js";
import useUserStore from "../Store/UserStore.js";
import useApplicationSettings from "../Store/ApplicationSettings.js";

export default function RiveArtboard(props) {
  const riveComponent = useSourceStore((state) => state.riveComponent);

  let reload;

  if (props.reloadVar) {
    for (let i = 0; i < props.reloadVar; i++) {
      reload.push(useUserStore((state) => state[props.reloadVar[i]]));
      reload.push(useApplicationSettings((state) => state[props.reloadVar[i]]));
    }
  }

  const { rive, RiveComponent } = useRive({
    src: riveComponent ? riveComponent : null,
    artboard: props.artboard,
    stateMachines: props.stateMachines,
    autoplay: true,
    layout: new Layout({
      fit: Fit.FitWidth, // Change to: rive.Fit.Contain, or Cover
      alignment: Alignment.Center,
    }),
  });

  if (props.reloadVar) {
    useEffect(() => {
      if (rive) {
        if (typeof props?.setup == "function") {
          props.setup(rive);
        }
      }
    }, reload);
  }

  useEffect(() => {
    if (rive) {
      if (typeof props?.setLoading == "function") {
        props.setLoading(false);
      }
      if (typeof props?.setupSetting == "function") {
        props.setupSetting(rive);
      }
      if (typeof props?.setup == "function") {
        props.setup(rive);
      }

      return () => [rive.cleanup()];
    }
  }, [rive]);

  return <RiveComponent />;
}
